import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment.local';
import { ModeService } from '../mode/mode.service';
import { AuthService } from './auth.service';
import { TenantAuthService } from './tenant-auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const tenantAuth = inject(TenantAuthService);
  const mode = inject(ModeService);
  const router = inject(Router);

  const apiBase = environment.apiBaseUrl.replace(/\/$/, '');
  const isApiCall = req.url.startsWith(apiBase) && req.url.includes('/api/');
  const isAnonymousClaim = req.url.includes('/api/claim/');
  const isPublicEndpoint = req.url.includes('/api/public/');
  const isAnonymousRecover = req.url.includes('/api/auth/recover/');
  const isAnonymous = isAnonymousClaim || isPublicEndpoint || isAnonymousRecover;
  const isTenantMode = mode.isTenant();
  const token = isTenantMode ? tenantAuth.token() : auth.token();

  const outgoing = token && isApiCall && !isAnonymous
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(outgoing).pipe(
    catchError((err) => {
      if (
        isApiCall &&
        !isAnonymous &&
        err instanceof HttpErrorResponse &&
        err.status === 401
      ) {
        if (isTenantMode && tenantAuth.isAuthenticated()) {
          tenantAuth.logout();
        } else if (!isTenantMode && auth.isAuthenticated()) {
          auth.logout();
          router.navigateByUrl('/');
        }
      }
      return throwError(() => err);
    }),
  );
};
